"use strict";
/**
 * @module Services.GatewayControl
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Gateway response from a get operation detail request.
 */
var GetOperationDetailResponse = /** @class */ (function () {
    /**
     * Create a new GetOperationDetailResponse instance
     *
     * @param type response type
     * @param description a detailed description of the operation
     * @param inputSchema JSON schema for the input of the operation (optional)
     * @param outputSchema JSOn schema for the output of the operation (optional)
     */
    function GetOperationDetailResponse(type, description, inputSchema, outputSchema) {
        this.type = type;
        this.description = description;
        this.inputSchema = inputSchema;
        this.outputSchema = outputSchema;
    }
    return GetOperationDetailResponse;
}());
exports.GetOperationDetailResponse = GetOperationDetailResponse;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/gateway-control/operations/get-operation-detail-response.js
// module id = 1250
// module chunks = 1